import { render, staticRenderFns } from "./TermsAndConditions.vue?vue&type=template&id=6c1a33d8&scoped=true&"
import script from "./TermsAndConditions.vue?vue&type=script&lang=js&"
export * from "./TermsAndConditions.vue?vue&type=script&lang=js&"
import style0 from "./TermsAndConditions.vue?vue&type=style&index=0&id=6c1a33d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1a33d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c1a33d8')) {
      api.createRecord('6c1a33d8', component.options)
    } else {
      api.reload('6c1a33d8', component.options)
    }
    module.hot.accept("./TermsAndConditions.vue?vue&type=template&id=6c1a33d8&scoped=true&", function () {
      api.rerender('6c1a33d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TermsAndConditions.vue"
export default component.exports